import { Dimensions } from "react-native";

const Metrics = {
  // Screen
  screenWidth: Dimensions.get("screen").width,
  screenHeight: Dimensions.get("screen").height,

  // Window
  windowWidth: Dimensions.get("window").width,
  windowHeight: Dimensions.get("window").height,

  // Font size
  fontSize8: 8,
  fontSize10: 10.0,
  fontSize12: 12.0,
  fontSize14: 14.0,
  fontSize16: 16.0,
  fontSize18: 18.0,
  fontSize20: 20.0,
  fontSize24: 24.0,

  // padding
  padding44: 44,
  padding32: 32,
  paddingExtraMedium: 28,
  padding24: 24,
  padding20: 20,
  padding16: 16,
  paddingSmallStandard: 12,
  paddingSmall10: 10,
  padding8: 8,
  padding6: 6,
  paddingSuperSmall: 4,
  paddingLudicrousSmall: 2,
  paddingMicroSmall: 1,

  // Button
  buttonLowOpacity: 0.2,
  buttonHighOpacity: 1,
  paddingVerticalButton: 10,
  paddingHorizontalButton: 20,

  // Border radius
  borderRadius8: 8.0,
  borderRadius6: 6.0,
  borderRadiusStandard: 4.0,
  borderRadiusSmall: 1.0,

  // Icons
  iconSuperLarge: 120,
  iconLarge: 32,
  iconMedium: 24,
  iconSmall: 20,
  iconSmaller: 16,
  iconExtraSmall: 12,
  iconSuperSmall: 10,

  // Menu
  menuRegularHeight: 40,
  menu44: 44,
  menuLargeHeight: 56,

  //Text Input
  textInputHeight: 32,

  // Heights
  size300: 300,
  size220: 220,
  size160: 160,
  size212: 212,
  size108: 108,
  size96: 96,
  size90: 90,
  size86: 86,
  size67: 67,
  size64: 64,
  size52: 52,
  size48: 48,
  size44: 44,
  size32: 32,
  size24: 24,
  size28: 28,
  size5: 5,
  size4: 4,
  size1: 1,
  editModalWidth: 352,
  editModalHeight: 200,
};

export default Metrics;
